export const state = () => {
  return {
    modal: null,
    modalStack: [],
  }
}
export const getters = {
  GET_MODAL(state) {
    return state.modal
  },
  GET_MODAL_STACK(state) {
    return state.modalStack
  },
}

export const mutations = {
  SET_MODAL(state, param: string) {
    state.modal = param
  },
  UNSET_MODAL(state) {
    state.modal = null
  },
  PUSH_MODAL_STACK: (state, id) => {
    if (!state.modalStack.includes(id)) {
      state.modalStack = [...state.modalStack, id]
    }
  },
  POP_MODAL_STACK: (state, id) => {
    if (state.modalStack.includes(id)) {
      state.modalStack = state.modalStack.filter((s) => s !== id)
    }
  },
}
